<template>
	<div class="job-submit">
		<ul class="job-con">
			<li class="x-flow"><h5 class="x-inline">{{ activePosInfo.activePosName }}</h5>
				<i class="x-icon-share x-inline" @click="posShare(1)"></i>
			</li>
			<li class="x-flow help-btn">
				<div @click="applySubmit">
					<button>Submit</button>
				</div>
			</li>
		</ul>
		<ul class="submit-con">
			<li>
				<h5>Contact Information</h5>
				<div class="base-form">
					<el-form ref="form"
							 :model="db.form"
							 :inline="conf.form.inline"
							 :label-width="conf.form.lwidth"
							 :label-position="conf.form.position"
							 :size="conf.form.size">
						<el-form-item label="Name the name on your identity card"
									  :label-width="conf.form.items.username">
							<el-input v-model="db.form.username"></el-input>
						</el-form-item>
						<el-form-item label="Country/Region" :label-width="conf.form.items.region">
							<el-select @change="onNationChange"
									   v-model="db.form.region"
									   :multiple="false"
									   no-data-text="No data"
									   :filterable="true"
									   :disabled="models.nationDisable"
									   placeholder="Country/Region">
								<el-option v-for="(item, key) in models.nations"
										   :label="item.name"
											 :key="key"
										   :value="JSON.stringify({
														       regionId: item.id,
														       regionName: item.name,
														       key: key
														   })"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Province/City" :label-width="conf.form.items.city">
							<el-select @change="onCityChange"
									   v-model="db.form.city"
									   :multiple="false"
									   no-data-text="Province/City"
									   :filterable="true"
									   :disabled="models.cityDisable"
									   placeholder="Province/City">
								<el-option v-for="(item, key) in models.cities"
										   :label="item.name"
											 :key="key"
										   :value="JSON.stringify({
														       regionId: item.id,
														       regionName: item.name,
														       key: key
														   })"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="Phone Number" :label-width="conf.form.items.mobile">
							<el-input v-model="db.form.mobile"></el-input>
						</el-form-item>
						<el-form-item label="Email" :label-width="conf.form.items.email">
							<el-input v-model="db.form.email"></el-input>
						</el-form-item>
					</el-form>
				</div>
			</li>
			<li>
				<h5 class="custome-file">Your works or other attachments</h5>
				<div class="base-file" v-if="conf.upload.update==false">
					<el-upload
					class="upload-refer x-show"
					drag
					:action="null"
					:show-file-list="false"
					:limit="conf.upload.maxLen"
					:before-upload="uploadCase"
					>
						<div class="el-upload-body">
							<!--<i class="el-icon-upload"></i>-->
							<div class="el-upload__text">
								<span>Drag and drop your works or other attachments to this area</span>
								<br/>
								<em>Upload your file</em>
							</div>
							<div class="upload-hit">
								<!--文件大小控制在 2M 以内，支持格式 .pdf/.doc/.docx-->
								The file size is controlled within 2M, and the supported formats are .pdf/.doc/.docx
							</div>
						</div>
					</el-upload>
				</div>
				<div class="loadok-area" v-if="conf.upload.update==true">
					<div class="file-con">
						<i class="x-file-icon"></i>
						<p class="x-file-name">{{ conf.upload.name }}</p>
					</div>
					<div class="update-btn">
						<el-button type="text">
							<el-upload
							:action="null"
							:show-file-list="false"
							:limit="conf.upload.maxLen"
							:before-upload="uploadCase"
							><span>Update</span>
							</el-upload>
						</el-button>
						<el-button type="text" @click="removeUpload">Delete</el-button>
					</div>
				</div>
				<div class="load-area" v-if="conf.upload.showBar">
					<el-progress
					type="line"
					:text-inside="true"
					color="#F67920"
					:stroke-width="26"
					:percentage="conf.upload.percent">
					</el-progress>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
    import tools from '../../../axios/index';
    import upload from '../../../axios/upload';
    export default {
        props: ['activePosId', 'activePosInfo'],
        data() {
            const _this = this;
            return {
                activeName: 3,
                db: {
                    form: {
                        username: '',
                        region: '',
                        city: '',
                        mobile: '',
                        email: '',
                        file: ''
                    }
                },
                conf: {
                    form: {
                        lwidth: 'auto',
                        position: 'top',
                        inline: true,
                        size: 'small',
                        items: {
                            username: '50.625rem',
                            region: '25rem',
                            city: '25rem',
                            mobile: '25rem',
                            email: '25rem'
                        }
                    },
                    upload: {
                        maxLen: 1,
                        percent: 0,
                        update: false,
                        showBar: false,
                        name: '',

                    }
                },
                models: {
                    from: '',
                    posname: '',
                    nations: [],
                    cities: [],
                    nationDisable: false,
                    cityDisable: false,

                }
            }
        },
        methods: {

            posShare(posid) {
                const _this = this;
                const params = {
                    url: 'http://127.0.0.1:8080/#/zh-cn/refer',
                    title: '职位分享',
                    source: '',
                    desc: 'Xhorse 新职位发布了，一睹为快。',
                    image: '',
                    summary: ''
                };
				/*const shareUrl = shconf.qq
				 .replace("{{URL}}", params['url'])
				 .replace("{{TITLE}}", params['title'])
				 .replace("{{SOURCE}}", params['source'])
				 .replace("{{DESC}}", params['desc'])
				 .replace("{{IMAGE}}", params['image'])
				 .replace("{{SUMMARY}}", params['summary']);

				 console.log(shareUrl)

				 window.open(shareUrl, '职位分享', 'height=100,width=100,top=100,left=100');*/
            },


            uploadCase(file) {
                const _this = this;
                const fileProps = {
                    fileName: file.name,
                    fileSize: file.size,
                    fileType: file.type
                };
                //console.log(file)
                const sync = new Promise((resolve, reject) => {
                    let handle = {resolve: resolve, reject: reject};
                    upload.getUploadWay(fileProps, handle, _this);
                }).then(res => {
                    //console.log(res);
                    //console.log(sync)
                    upload.uploadToS3(res, file, _this);
                }).catch(err => {
                    //console.log(err);
                    _this.$message.error(err);
                });
                return false;
            },

            removeUpload() {
                const _this = this;
                Object.assign(_this.$data.db.form.file, _this.$options.data().db.form.file);
                Object.assign(_this.$data.conf.upload, _this.$options.data().conf.upload);
            },

            applySubmit() {
                const _this = this;
                var data = _this.db.form;
                const posid = _this.activePosId;
                if (isNaN(posid) || posid == 0) {
                    _this.$message.warning('Oh,error');
                    return;
                }
                data['posid'] = parseInt(posid);
                if ($.trim(data.username) == '') {
                    _this.$message.warning('Please enter your name');
                    return;
                }
                if ($.trim(data.region) == '') {
                    _this.$message.warning('Please select region');
                    return;
                }
                if ($.trim(data.mobile) == '') {
                    _this.$message.warning('Please enter your phone number');
                    return;
                }
                if ($.trim(data.email) == '') {
                    _this.$message.warning('Please fill in the email');
                    return;
                }
                if ($.trim(data.file) == '') {
                    _this.$message.warning('Please upload your work or resume');
                    return;
                }
                if ($.isPlainObject(data.region) === false) {
                    data.region = JSON.parse(data.region);
                }
                if ($.isPlainObject(data.city) === false) {
                    data.city = JSON.parse(data.city);
                }
                tools.applyDone({data: data}, _this);
            },

            onNationChange(value) {
                const _this = this;
                const nation = JSON.parse(value);
                tools.getRegion({regionId: nation.regionId}, _this);
                _this.db.form.city = '';
            },
            onCityChange(value) {
                const _this = this;
                const city = JSON.parse(value);
                //console.log(_this.db.form)
            },
            // 获取地区
            getRegion(regionId) {
                const _this = this;
                if (isNaN(regionId)) {
                    return false;
                }
                tools.getRegion({regionId: regionId}, _this);
            },


            addClass(selector) {
                $(selector).addClass("x-active").removeClass("x-inactive");
            }
        },
        mounted() {
            const _this = this;
            const router = _this.$router;
            const params = router.history.current.params;
            //console.log(router)
            let pos = undefined;
            if ($.isEmptyObject(params)) {
                pos = _this.$cache.getStorage("x-apply-list");
                _this.models.from = pos.from;
                _this.models.posid = pos.posid;
                _this.models.posname = pos.posname;
            } else {
                _this.models.from = params.from;
                _this.models.posid = params.posid;
                _this.models.posname = params.posname;
                pos = _this.models;
            }
            _this.db.form.posid = _this.models.posid;
            _this.addClass('.x-' + _this.models.from);
            _this.getRegion(0);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.custome-file {
		font-size: 1.5rem;
		color: #2B2E2E;
	}

	.el-upload__text {
		display: block;
		width: 80%;
		margin: 0 auto;
	}

	.base-file {
		padding-top: 1.25rem;
		width: 30rem;
	}

	.el-upload .el-upload-body {
		position: absolute;
		width: 100%;
		height: 9.75rem;
		text-align: center;
		/* margin: 0 auto; */
		line-height: 1.5rem;
		/* padding-top: 24px; */
		/* left: 5%; */
		padding-top: 1.5rem;
	}

	.el-upload .upload-hit {
		width: 80%;
		margin: 0 auto;
		font-size: .875rem;
		color: #999999;
		letter-spacing: 0.03px;
		line-height: 1.125rem;
		margin-top: 1rem;
		margin-bottom: 2rem;
		word-wrap: break-word;
	}

	.el-upload__text em {
		cursor: pointer;
		display: inline-block;
		padding: 0 1.125rem;
		margin-top: 0px;
		/* margin-bottom: 32px; */
		height: 2.875rem;
		line-height: 2.875rem;
		font-size: 1.125rem;
		color: #0052D9;
		letter-spacing: 0.09px;
		background: #FFFFFF;
		border: .0625rem solid #D8D8D8;
		box-sizing: border-box;
		transition: .5s background cubic-bezier(0.2, 0.0, 0.2, 1);
	}

	.load-area {
		width: 30rem;
		height: 3rem;
		padding-top: 1.5rem;
	}

	.file-con .x-file-icon {
		display: block;
		content: "";
		/*position: absolute;
		left: 0;
		right: 0;*/
		margin: 0 auto;
	}

	.loadok-area {
		background-color: #fff;
		border: 1px dashed #d9d9d9;
		border-radius: .375rem;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 30rem;
		height: 11.25rem;
		text-align: center;
		position: relative;
		overflow: hidden;
		margin-top: 1.25rem;
	}

	.loadok-area .file-con {
		width: 100%;
		height: 6.25rem;
		padding-top: 1.5rem;
		border-bottom: .0625rem solid #d9d9d9;
		/*background: #F7F7F7;*/
	}

	.file-con .x-file-name {
		margin-top: 1rem;
		margin-bottom: 2.4375rem;
		font-size: 1.5rem;
		color: #333333;
		letter-spacing: 0.05px;
		line-height: 1.5rem;
		font-weight: 600;
		font-family: inherit;
		overflow: hidden;
	}

	.loadok-area .update-btn {
		width: 100%;
		height: 3.5rem;
		border: none;
		text-align: left;
	}

	.update-btn button:nth-child(1) {
		margin-left: 3rem;
	}

	.update-btn button {
		height: 3.5rem;
		border: none;
		color: #333333;
		cursor: pointer;
	}

	.update-btn button:nth-child(1):hover {
		color: #F67920;
	}

	.update-btn button:nth-child(2):hover {
		color: #d81e06;
	}

	.el-form > .el-form-item:first-child {
		width: calc(100% - .625rem);
	}

	.el-form > .el-form-item:not(:first-child) {
		width: calc((100% - 1.25rem) / 2);
		padding: 0;
		margin: 0;
	}

	.el-form > .el-form-item:nth-child(3), .el-form > .el-form-item:nth-child(5) {
		margin-left: .3125rem;
	}

	.el-form-item .el-select {
		width: 100%;
	}

	.el-form > .el-form-item {
		border: none;
	}

	.base-form > .el-form {
		width: 100%;
	}

	.submit-con > li:nth-child(1) > h5 {
		width: 60%;
		font-size: 1.5rem;
		color: #2B2E2E;
	}

	.submit-con > li {
		border: none;
		width: 50.625rem;
		text-align: left;
	}

	.submit-con {
		border: none;
		min-height: 51rem;
		width: 77.5rem;
		margin: 0 auto;
	}

	.job-con > li {
		height: 4.5rem;
	}

	.job-con > li:nth-child(1) {
		width: 75%;
		text-align: left;
	}

	.job-con > li:nth-child(1) > h5 {
		font-size: 2.25rem;
		color: #3B3A38;
	}

	.job-con > li:nth-child(2) {
		width: 25%;
		text-align: right;
	}

	.job-submit {
		width: 100%;
		min-height: 58.8125rem;
	}

	.job-con {
		width: 77.5rem;
		height: 4.5rem;
		margin: 0 auto;
		margin-top: 3.3125rem;
	}

	.x-icon-share {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_recruit_share.png");
		width: 2rem;
		height: 2rem;
	}

	.help-btn button {
		height: 2.875rem;
		border: none;
		margin: 0;
		background: #F67920;
		color: #ffffff;
		border-radius: .25rem;
		width: 9.8125rem;
		outline: 0;
		cursor: pointer;
	}

	.base-form {
		width: 100%;
		padding: 1.25rem 0 1.25rem 0;
	}

</style>






// WEBPACK FOOTER //
// src/components/zh-cn/join/join-submit.vue